export default {
  add_items: 'Artikel hinzufügen',
  remove_items: 'Artikel entfernen',
  place_order: 'Bestellung aufgeben',
  pay_now: 'Jetzt bezahlen',

  terms:
    'Mit Ihrer Bestellung erklären Sie sich mit unseren <TermsLink>Allgemeinen Geschäftsbedingungen</TermsLink> und unserer <PrivacyPolicyLink>Datenschutzerklärung</PrivacyPolicyLink> einverstanden.',

  modals: {
    account_switch: {
      title: 'Das Konto mit der Telefonnummer {{phoneNumber}} existiert bereits',
      description:
        'Wir haben dich sorgfältig in das vorhandene Konto eingeloggt und dabei die Informationen, die du eingegeben hast, behalten 😊',
      button: 'Weiter',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Zahlung fehlgeschlagen',
      description: 'Bitte überprüfe deine Zahlungsinformationen und versuchen es erneut.',
    },
  },

  toasts: {
    input_errors_found: 'Es gibt einige Probleme mit den Bestelldaten',
  },
};
